/**
 * Meta Pixel helpers.
 * The base pixel is initialised in /public/index.html so PageView fires as
 * soon as the site loads (before React is even mounted).
 *
 * From React we use these helpers to fire custom events and, if the admin
 * changes the pixel ID from the panel, to re-init the pixel at runtime.
 */

const DEFAULT_ID = '940049328402164';

const getFbq = () => {
  if (typeof window === 'undefined') return null;
  return window.fbq || null;
};

/** Ensure a given pixel id is initialised. Safe to call multiple times. */
export const ensurePixel = (pixelId) => {
  const fbq = getFbq();
  if (!fbq || !pixelId) return;
  window.__META_PIXEL_INITED__ = window.__META_PIXEL_INITED__ || {};
  if (window.__META_PIXEL_INITED__[pixelId]) return;
  try {
    fbq('init', String(pixelId));
    window.__META_PIXEL_INITED__[pixelId] = true;
  } catch (e) {
    // never break the app for tracking
    // eslint-disable-next-line no-console
    console.warn('[metaPixel] init failed', e);
  }
};

/** Fire a standard event (e.g. InitiateCheckout, Purchase).
 * If `params.eventID` is provided, it's extracted and passed as the 4th
 * argument to fbq — Meta uses it for server↔client deduplication (CAPI).
 */
export const trackEvent = (eventName, params) => {
  const fbq = getFbq();
  if (!fbq) return;
  try {
    if (params && typeof params === 'object') {
      const { eventID, ...rest } = params;
      if (eventID) {
        fbq('track', eventName, rest, { eventID: String(eventID) });
      } else {
        fbq('track', eventName, rest);
      }
    } else {
      fbq('track', eventName);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[metaPixel] track failed', eventName, e);
  }
};

/** Track PageView (used only if we ever need to fire manually). */
export const trackPageView = () => trackEvent('PageView');

export const META_PIXEL_DEFAULT_ID = DEFAULT_ID;
